// ProtectedRoute.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { NotFoundPage } from './NotFoundPage';


export const ProtectedRoute = ({ allowedRoles, userRole }) => {
  const location = useLocation();

  if (!allowedRoles.includes(userRole)) {
    return <NotFoundPage />;
  }

  return <Outlet />;
};